import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Checkbox, Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'

import { FBSCommInfo } from '../Types'
import { SystemHeader } from '../CommonUI';
import { Pagination, PageInfo } from '../CommonUI';

import i18next from 'i18next';


var GsbFlag: any;

var UserID: string;
var PgmCode = "FM0024" ;
var isReqAuth2:boolean = false ;

interface FBSCommMastViewProps {
    gsb: AxiosInstance,
    CommInfo: FBSCommInfo,
    CommInfo0: FBSCommInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
}


export function FBSCommMastView({ gsb, CommInfo = {} as FBSCommInfo, CommInfo0 = {} as FBSCommInfo,baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2 }: FBSCommMastViewProps) {


    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
/*
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
*/

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, CommInfo])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_Comdy" in CommInfo)) return null


    return (
        <div>
            {/* define add,change,delete button */}
            { ViewMode === "V" && <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }
            </div> }
            { ViewMode === "L" && <div>
                Commission Class : {CommInfo.d_CommCode}
                { (logKey2.indexOf("*A1") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Amend</div> }
                { (logKey2.indexOf("*C") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Create</div> }
                { (logKey2.indexOf("*D") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Delete</div> }
                { ! (CommInfo0.d_AuthId.toString() == "") && <div id="DispText2">Auth : {utils.dispDate(CommInfo0.d_AuthDate, "3")} {CommInfo0.d_AuthTime} User {CommInfo0.d_AuthId} </div> }
                <div className="Spacing-V-16" />
            </div> }

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Commission Class">
                    <InputGroup readOnly value={CommInfo.d_CommCode} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="Commodity">
                    <InputGroup readOnly value={CommInfo.d_Comdy} />
                </FormGroup>
                <FormGroup className="Col-3-3" label="Name">
                    <div id="DispText">{CommInfo.d_ComdyName}</div>
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-3" disabled inline selectedValue={CommInfo.d_Type} label="Type" onChange={()=>{}}>
                    <Radio label="Normal" value="N" />
                    <Radio label="Takeup" value="T" />
                    <Radio label="Giveup" value="G" />
                </RadioGroup>
                { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_Type.toString() == "") && 
                <div id="DispText2" > {CommInfo0.d_Type} </div> }
            </div>

            <div className="Spacing-V-16" />
            <H5>FUTURES</H5>
            <div className="Row Form-Section-Label">
                <div className="Col-1-2">Commission</div><div className="Col-3-2">Rebate</div>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Day Trade">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_FDRate1)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_FDRate1.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_FDRate1)} </div> }
                </FormGroup>
                <FormGroup className="Col-2-1" label="Overnight">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_FNRate1)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_FNRate1.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_FNRate1)} </div> }
                </FormGroup>
                <FormGroup className="Col-3-1" label="Day Trade">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_FDRRate1)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_FDRRate1.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_FDRRate1)} </div> }
                </FormGroup>
                <FormGroup className="Col-4-1" label="Overnight">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_FNRRate1)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_FNRRate1.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_FNRRate1)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Cash Settle">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_FCash)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_FCash.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_FCash)} </div> }
                </FormGroup>
                <FormGroup className="Col-3-1" label="Cash Settle">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_FRCash)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_FRCash.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_FRCash)} </div> }
                </FormGroup>
            </div>

            <div className="Spacing-V-16" />
            <H5>OPTIONS</H5>
            <div className="Row Form-Section-Label">
                <div className="Col-1-2">Commission</div><div className="Col-3-2">Rebate</div>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Trade">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_ORate1)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_ORate1.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_ORate1)} </div> }
                </FormGroup>
                <FormGroup className="Col-3-1" label="Trade">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_ORRate1)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_ORRate1.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_ORRate1)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Exercise / Assign">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_OExe)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_OExe.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_OExe)} </div> }
                </FormGroup>
                <FormGroup className="Col-3-1" label="Exercise / Assign">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_ORExe)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_ORExe.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_ORExe)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Expiry">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_OExp)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_OExp.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_OExp)} </div> }
                </FormGroup>
                <FormGroup className="Col-3-1" label="Expiry">
                    <InputGroup readOnly type='number' value={utils.numToString(CommInfo.d_ORExp)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (CommInfo0.d_ORExp.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(CommInfo0.d_ORExp)} </div> }
                </FormGroup>
            </div>
        </div>
    )
}

interface FBSCommMastEditProps {
    gsb: AxiosInstance,
    CommInfo?: FBSCommInfo,
    isNew?: boolean,
    onSave?: (stk: FBSCommInfo) => void,
    onCancel?: () => void,
}

export function FBSCommMastEdit({ gsb, CommInfo = {} as FBSCommInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: FBSCommMastEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FBSCommInfo>()

    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [ComdyValue, setComdyValue] = useState(CommInfo.d_Comdy)
    const [ComdyNameValue, setComdyNameValue] = useState(CommInfo.d_ComdyName)
    const [TypeValue, setTypeValue] = useState(CommInfo.d_Type || "N")

    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastEdit UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])

    useEffect(() => {
        // Call reset to get the values of record ClientTranInfo 
        if ("d_Comdy" in CommInfo) {
            reset(CommInfo)
        }
    }, [CommInfo, reset])


    useEffect(() => {
        // Some components (e.g. Suggest) don't have ref to use with react-hook-form, so register the fields manually and call setValue when item is selected
        // register({ name: "d_FieldName" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "ComdyMast", cAction: "GetComdyInfo", cComdy: ComdyValue})
                
                if ( ComdyValue.trim().length > 0 && res.data.count > 0 )
                {
                    setComdyNameValue(res.data.data[0].d_ComdyName)

                } else { 
                    setComdyNameValue("")
                }
               
            } catch (error) {
                //showErrorBox(error)
            }
        })()
    }, [gsb, ComdyValue])

    if (! isNew && ! ("d_Comdy" in CommInfo)) return null

   
    const onSubmit = (data: FBSCommInfo) => {
        // put value to json/field before write database dbf
        data.d_Type = TypeValue;

        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }

        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: data, cPgmId: "CommMast", cAction: "CommValidate", isNew: isNew})

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Commission Class" labelFor="d_CommCode" labelInfo="*">
                    <InputGroup disabled={!isNew} id="d_CommCode" name="d_CommCode" autoFocus={isNew} defaultValue={CommInfo.d_CommCode} placeholder="Commossion Class ..." onChange={utils.handleStringChange(s => setValue("d_CommCode", s.toUpperCase()))} inputRef={register({ required: true , maxLength: 10}) } />
                    {errors.d_CommCode && errors.d_CommCode.type === "required" && <span id="Err_msg">Commossion Class cannot be Blank</span>}
                    {errors.d_CommCode && errors.d_CommCode.type === "maxLength" && <span id="Err_msg">Max length is 10</span>}
                    {errors.d_CommCode && errors.d_CommCode.types && <span id="Err_msg">{errors.d_CommCode.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Commodity" labelFor="d_Comdy" labelInfo="*">
                    <InputGroup disabled={!isNew} id="d_Comdy" name="d_Comdy" value={ComdyValue} placeholder="Commodity ..." onChange={utils.handleStringChange(s => setComdyValue(s.toUpperCase()))} inputRef={register({ required: true , maxLength: 5}) } />
                    {errors.d_Comdy && errors.d_Comdy.type === "required" && <span id="Err_msg">Commodity cannot be Blank</span>}
                    {errors.d_Comdy && errors.d_Comdy.type === "maxLength" && <span id="Err_msg">Max length is 5</span>}
                    {errors.d_Comdy && errors.d_Comdy.types && <span id="Err_msg">{errors.d_Comdy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-3" label="Commodity Name" labelFor="d_ComdyName">
                    <div id="DispText">{ComdyNameValue}</div>
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-3" inline selectedValue={TypeValue} label="Type" onChange={utils.handleStringChange(s => setTypeValue(s))}>
                    <Radio label="Normal" value="N" />
                    <Radio label="Takeup" value="T" />
                    <Radio label="Giveup" value="G" />
                </RadioGroup>
            </div>

            <div className="Spacing-V-16" />
            <H5>FUTURES</H5>
            <div className="Row Form-Section-Label">
                <div className="Col-1-2">Commission</div><div className="Col-3-2">Rebate</div>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Day Trade" labelFor="d_FDRate1">
                    <InputGroup id="d_FDRate1" name="d_FDRate1" autoFocus={! isNew} defaultValue={"0"} type="number" placeholder="Day Trade ..." inputRef={register({ min: 0}) } />
                    {errors.d_FDRate1 && errors.d_FDRate1.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_FDRate1 && errors.d_FDRate1.types && <span id="Err_msg">{errors.d_FDRate1.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Overnight" labelFor="d_FNRate1">
                    <InputGroup id="d_FNRate1" name="d_FNRate1" defaultValue={"0"} type="number" placeholder="Overnight ..." inputRef={register({ min: 0}) } />
                    {errors.d_FNRate1 && errors.d_FNRate1.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_FNRate1 && errors.d_FNRate1.types && <span id="Err_msg">{errors.d_FNRate1.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Day Trade" labelFor="d_FDRRate1">
                    <InputGroup id="d_FDRRate1" name="d_FDRRate1" defaultValue={"0"} type="number" placeholder="Day Trade ..." inputRef={register({ min: 0}) } />
                    {errors.d_FDRRate1 && errors.d_FDRRate1.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_FDRRate1 && errors.d_FDRRate1.types && <span id="Err_msg">{errors.d_FDRRate1.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-4-1" label="Overnight" labelFor="d_FNRRate1">
                    <InputGroup id="d_FNRRate1" name="d_FNRRate1" defaultValue={"0"} type="number" placeholder="Overnight ..." inputRef={register({ min: 0}) } />
                    {errors.d_FNRRate1 && errors.d_FNRRate1.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_FNRRate1 && errors.d_FNRRate1.types && <span id="Err_msg">{errors.d_FNRRate1.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Cash Settle" labelFor="d_FCash">
                    <InputGroup id="d_FCash" name="d_FCash" defaultValue={"0"} type="number" placeholder="Cash Settle ..." inputRef={register({ min: 0}) } />
                    {errors.d_FCash && errors.d_FCash.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_FCash && errors.d_FCash.types && <span id="Err_msg">{errors.d_FCash.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Cash Settle" labelFor="d_FRCash">
                    <InputGroup id="d_FRCash" name="d_FRCash" defaultValue={"0"} type="number" placeholder="Cash Settle ..." inputRef={register({ min: 0}) } />
                    {errors.d_FRCash && errors.d_FRCash.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_FRCash && errors.d_FRCash.types && <span id="Err_msg">{errors.d_FRCash.types.message}</span>}
                </FormGroup>
            </div>

            <div className="Spacing-V-16" />
            <H5>OPTIONS</H5>
            <div className="Row Form-Section-Label">
                <div className="Col-1-2">Commission</div><div className="Col-3-2">Rebate</div>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Trade" labelFor="d_ORate1">
                    <InputGroup id="d_ORate1" name="d_ORate1" defaultValue={"0"} type="number" placeholder="Trade ..." inputRef={register({ min: 0}) } />
                    {errors.d_ORate1 && errors.d_ORate1.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_ORate1 && errors.d_ORate1.types && <span id="Err_msg">{errors.d_ORate1.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Trade" labelFor="d_ORRate1">
                    <InputGroup id="d_ORRate1" name="d_ORRate1" defaultValue={"0"} type="number" placeholder="Trade ..." inputRef={register({ min: 0}) } />
                    {errors.d_ORRate1 && errors.d_ORRate1.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_ORRate1 && errors.d_ORRate1.types && <span id="Err_msg">{errors.d_ORRate1.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Exercise / Assign" labelFor="d_OExe">
                    <InputGroup id="d_OExe" name="d_OExe" defaultValue={"0"} type="number" placeholder="Exercise / Assign ..." inputRef={register({ min: 0}) } />
                    {errors.d_OExe && errors.d_OExe.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_OExe && errors.d_OExe.types && <span id="Err_msg">{errors.d_OExe.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Exercise / Assign" labelFor="d_ORExe">
                    <InputGroup id="d_ORExe" name="d_ORExe" defaultValue={"0"} type="number" placeholder="Exercise / Assign ..." inputRef={register({ min: 0}) } />
                    {errors.d_ORExe && errors.d_ORExe.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_ORExe && errors.d_ORExe.types && <span id="Err_msg">{errors.d_ORExe.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Expiry" labelFor="d_OExp">
                    <InputGroup id="d_OExp" name="d_OExp" defaultValue={"0"} type="number" placeholder="Expiry ..." inputRef={register({ min: 0}) } />
                    {errors.d_OExp && errors.d_OExp.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_OExp && errors.d_OExp.types && <span id="Err_msg">{errors.d_OExp.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Expiry" labelFor="d_ORExp">
                    <InputGroup id="d_ORExp" name="d_ORExp" defaultValue={"0"} type="number" placeholder="Expiry ..." inputRef={register({ min: 0}) } />
                    {errors.d_ORExp && errors.d_ORExp.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_ORExp && errors.d_ORExp.types && <span id="Err_msg">{errors.d_ORExp.types.message}</span>}
                </FormGroup>
            </div>
        </form>
    )
}

interface FBSCommMastMainProps {
    gsb: AxiosInstance
}

// const toaster = Toaster.create({
//     position: Position.TOP,
// })

function FBSCommMastMain({ gsb }: FBSCommMastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { comdy: defaultSearchValue = "", dmon: defaultSearchValue2 }: { comdy: string, dmon: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as FBSCommInfo[])

    const [searchKey, setSearchKey] = useState("market")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)
    const [searchValue2, setSearchValue2] = useState(defaultSearchValue2)

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentCommInfo, setcurrentCommInfo] = useState({} as FBSCommInfo)
    const [CurrentLog1, setCurrentLog1] = useState({} as FBSCommInfo)
    const [CurrentLog0, setCurrentLog0] = useState({} as FBSCommInfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                UserID = res.data.Flag.UserID
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])

    useEffect(() => {

        if (logviewonly === "Y") {
            setViewMode("L")
        }
        //console.log("ClMastMain ViewMode: ", ViewMode)

        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 ) {
                    const res = await gsb.post('/fbs/Master', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "CommMast", 
                        cAction: "ViewLogRec"
                    })
                    //console.log("CommMastMain ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog0(res.data.data[0])
                        setCurrentLog1(res.data.data[1])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])


    const PrevRecProcess = async (CommInfo: FBSCommInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: CommInfo, cPgmId: "CommMast", cAction: "PrevRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_CommCode+data[i].d_Comdy+data[i].d_Type === res.data.data.d_CommCode+res.data.data.d_Comdy+res.data.data.d_Type) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentCommInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (CommInfo: FBSCommInfo) => {
        try {
            CommInfo.d_AuthTran = ""
            if (isReqAuth2) {
                CommInfo.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/fbs/Master', {sb_data: CommInfo, cPgmId: "CommMast", cAction: "DelRec"})
            if (isReqAuth2) {
                utils.showSuccess("Commission Class " + CommInfo.d_CommCode+" "+CommInfo.d_Comdy+" "+CommInfo.d_Type + " record deleting, waiting for authorization")
            } else {
                utils.showSuccess("Commission Class " + CommInfo.d_CommCode+" "+CommInfo.d_Comdy+" "+CommInfo.d_Type + " record deleted")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_CommCode+data[i].d_Comdy+data[i].d_Type === res.data.data.d_CommCode+res.data.data.d_Comdy+res.data.data.d_Type) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setcurrentCommInfo(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                setShowAlert1Msg("Commission Class " + CommInfo.d_CommCode+" "+CommInfo.d_Comdy+" "+CommInfo.d_Type + " record deleting, waiting for authorization")
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (CommInfo: FBSCommInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: CommInfo, cPgmId: "CommMast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_CommCode+data[i].d_Comdy+data[i].d_Type === res.data.data.d_CommCode+res.data.data.d_Comdy+res.data.data.d_Type) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentCommInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (CommInfo: FBSCommInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: CommInfo, cPgmId: "CommMast", cAction: "AddRec"})
            if (isReqAuth2) {
                utils.showSuccess("Commission Class " + CommInfo.d_CommCode+" "+CommInfo.d_Comdy+" "+CommInfo.d_Type + " record adding, waiting for authorization")
            } else {
                utils.showSuccess("Commission Class " + CommInfo.d_CommCode+" "+CommInfo.d_Comdy+" "+CommInfo.d_Type + " record added")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_CommCode+data[i].d_Comdy+data[i].d_Type === res.data.data.d_CommCode+res.data.data.d_Comdy+res.data.data.d_Type) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setcurrentCommInfo(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                setShowAlert1Msg("Commission Class " + CommInfo.d_CommCode+" "+CommInfo.d_Comdy+" "+CommInfo.d_Type + " record adding, waiting for authorization")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (CommInfo: FBSCommInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: CommInfo, cPgmId: "CommMast", cAction: "UpdateRec"})
            if (isReqAuth2) {
                utils.showSuccess("Commission Class " + CommInfo.d_CommCode+" "+CommInfo.d_Comdy+" "+CommInfo.d_Type + " record saving, waiting for authorization")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_CommCode+data[i].d_Comdy+data[i].d_Type === res.data.data.d_CommCode+res.data.data.d_Comdy+res.data.data.d_Type) {
                        setcurrentCommInfo(data[i])
                        break
                    }
                }
                setCurrentMode("show")
                setisShowAlert1(true)
                setShowAlert1Msg("Commission Class " + CommInfo.d_CommCode+" "+CommInfo.d_Comdy+" "+CommInfo.d_Type + " record saving, waiting for authorization")
            } else {
                utils.showSuccess("Commission Class " + CommInfo.d_CommCode+" "+CommInfo.d_Comdy+" "+CommInfo.d_Type + " record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_CommCode+data[i].d_Comdy+data[i].d_Type === res.data.data.d_CommCode+res.data.data.d_Comdy+res.data.data.d_Type) {
                        data[i] = { ...data[i], ...res.data.data }
                        //console.log("editOnSave data", i, data)
                        setData(data)
                        break
                    }
                }
                //console.log("editOnSave res.data.data", res.data.data)
                setcurrentCommInfo(res.data.data)
                setCurrentMode("show")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        try {
            //console.log("CommMastMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        start2: searchValue2,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                        }, 
                    },
                    cPgmId: "CommMast",
                    cAction: "ListRec",
                });

                //console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentCommInfo(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        d_Comdy: searchValue,
                        d_DMon: searchValue2,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "CommMast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setcurrentCommInfo(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("CommMastMain useEffect length > 0  called", data)
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "market",
                            start: defaultSearchValue,
                            start2: defaultSearchValue2,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "CommMast",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentCommInfo(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue, defaultSearchValue2])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            start2: searchValue2,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                            }, 
                        },
                        cPgmId: "CommMast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setcurrentCommInfo(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    // currentMode = show
    let detail = <FBSCommMastView gsb={gsb} CommInfo={currentCommInfo} CommInfo0={currentCommInfo} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentCommInfo)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentCommInfo)} onNextRec={() => NextRecProcess(currentCommInfo)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></FBSCommMastView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <FBSCommMastEdit gsb={gsb} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></FBSCommMastEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <FBSCommMastEdit gsb={gsb} CommInfo={currentCommInfo} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></FBSCommMastEdit>
            break
    }

    let logKeyViewRec = <FBSCommMastView gsb={gsb} CommInfo={CurrentLog1} CommInfo0={CurrentLog0} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentCommInfo)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentCommInfo)} onNextRec={() => NextRecProcess(currentCommInfo)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></FBSCommMastView>

    let pagination = <Pagination nPage={nPage} nTotalPage={nTotalPage} aPageNumber={aPageNumber} setnPage={(n)=>setnPage(n)}></Pagination>
    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-150">Commission Class</th>
                <th className="TCol-100">Commodity</th>
                <th className="TCol-100">Type</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((CommInfo, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td onClick={() => { setcurrentCommInfo(CommInfo) ; MoblieDev && setSelectedTabId("detail") }}>{CommInfo.d_CommCode}</td>
                        <td onClick={() => { setcurrentCommInfo(CommInfo) ; MoblieDev && setSelectedTabId("detail") }}>{CommInfo.d_Comdy}</td>
                        <td onClick={() => { setcurrentCommInfo(CommInfo) ; MoblieDev && setSelectedTabId("detail") }}>{CommInfo.d_Type}</td>
                        {/* <td onClick={() => { setcurrentCommInfo(CommInfo) }}>{CommInfo.d_Action}</td> */}
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Commission Class</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="commCode">Commission Class</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                />
                                <InputGroup
                                    id="inputSearchValue2"
                                    placeholder=""
                                    value={searchValue2}
                                    onChange={utils.handleStringChange(s => setSearchValue2(s))}
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "comdy"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "comdy"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        </div>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Commission Class Log View</H3>
                    <div className="Spacing-V-16" />
                    {logKeyViewRec}
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default FBSCommMastMain